<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Adicionar novo Equipamento"
    type-modal="add_equipment_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feName">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" v-if="model.id"/>
            <autocomplete
              v-else
              ref="autocomplete"
              placeholder="Equipamento"
              :items="equipments"
              item-show="name"
              :on-input="onInput"
              :on-select="setEquipment"
              :on-blur="setEquipmentBlur"
              :on-show-text="showText"
            ></autocomplete>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy, capitalize } from '_utils';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import ModalTemplate from '_shared/Modal.vue';
import ProductService from '_services/rest/modules/product';
import { PRODUCT_TYPE_OPTIONS, _LOAD_EQUIPMENT_, _RELOAD_EQUIPMENT_ } from '../ProductModel';

export default {
  name: 'add-equipment-modal',
  components: {
    Autocomplete,
    ModalTemplate,
  },
  computed: {
    equipments() {
      const { equipments } = this.$store.state.product;
      if (equipments && equipments.length) {
        return equipments;
      }
      return [];
    },
  },
  data() {
    return {
      loading: false,
      productId: null,
      model: PRODUCT_TYPE_OPTIONS,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getEquipments',
    ]),
    cancel() {
      this.setToggle({ type: 'add_equipment_modal', bool: false });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getEquipments(name);
      }, 500);
    },
    save() {
      this.toggleLoading();
      this.model.name = capitalize(this.model.name);
      this.model.slug = stringfy(this.model.name);
      ProductService.saveEquipment(this.productId, this.model)
        .then(response => {
          this.cancel();
          Events.$emit(_RELOAD_EQUIPMENT_, response);
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
        .finally(() => this.toggleLoading());
    },
    setEquipment(equipment) {
      this.model = equipment;
    },
    setEquipmentBlur(value) {
      if (this.model.id === null) {
        this.model.name = value;
      }
    },
    showText(item) {
      return `<strong>${item.id}</strong> ${item.name} `;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_EQUIPMENT_, ({ id, option }) => {
      this.productId = id;
      this.model = { ...option };
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
